import type { IDropdownItem } from "@similarweb/ui-components";
import { DomainsChipDownContainer } from "@similarweb/ui-components";
import { ListItemWebsite } from "@similarweb/ui-components";
import { chosenSites } from "app/common/services/chosenSites";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import useCompetitiveQueryParams from "../../hooks/useCompetitiveQueryParams";
import { COMPETITIVE_LANDSCAPE_ROUTE_NAME } from "../../configuration/constants";
import getChosenSitesFilters from "../../helpers/getChosenSitesFilters";
import { StyledChipWrap } from "../CompetitiveFilter/styles";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

export const CompetitiveSiteFilter = () => {
    const { selectedSiteFilter } = useCompetitiveQueryParams();
    const isCompare = chosenSites.isCompare();
    const chosenSiteFilters = getChosenSitesFilters();
    const t = useTranslation();

    if (!isCompare) {return null;}

    const handleSelectSite = (selectedSite: IDropdownItem) => {
        proNavigator.go(
            COMPETITIVE_LANDSCAPE_ROUTE_NAME,
            Object.assign(proNavigator.getParams(), { selectedSite: selectedSite.text }),
        );
    };

    const handleClearSite = () => {
        proNavigator.go(
            COMPETITIVE_LANDSCAPE_ROUTE_NAME,
            Object.assign(proNavigator.getParams(), { selectedSite: null }),
        );
    };

    return (
        <StyledChipWrap>
            <DomainsChipDownContainer
                onClick={handleSelectSite}
                selectedIds={{ [selectedSiteFilter.value]: true }}
                selectedDomainText={selectedSiteFilter.label}
                selectedDomainIcon={selectedSiteFilter.icon}
                onCloseItem={handleClearSite}
                buttonText={selectedSiteFilter.label}
                noResultsMessage={t("dropdown.no.results")}
            >
                {chosenSiteFilters.map((item) => {
                    const { label, icon } = item;
                    return (
                        <ListItemWebsite
                            key={label}
                            text={label}
                            img={icon}
                        />
                    );
                })}
            </DomainsChipDownContainer>
        </StyledChipWrap>
    );
};
